import { render, staticRenderFns } from "./DogTypeMaintenance.vue?vue&type=template&id=0352f90a"
import script from "./DogTypeMaintenance.vue?vue&type=script&lang=ts"
export * from "./DogTypeMaintenance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports